import http from "./axios";

// 查询提现记录
export const withDrawList = () => {
  return http.get("/account/redEnvelope/logPage");
};
